export default __webpack_public_path__ + "static/media/A40D.4d063200.jpg";